import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';

/**
 * A back button on wiki article pages.
 *
 * Core's phone bar shows "back" only when app.history has something to go back
 * to, and a page puts itself there with app.history.push(). A discussion and a
 * profile do; the wiki's pages never did, so on a phone a wiki article showed
 * the menu button alone while every other page inside a section had back
 * (Karl, 2026-10-27).
 *
 * Done here rather than in the wiki extension: any page extends core's Page,
 * so this watches the page's route name instead of importing the wiki's code
 * (which loads on demand and would be pulled in on every page).
 *
 * The wiki index goes onto the stack first when it is not already there, so
 * back from an article lands on /wiki, also when the article was the first
 * page loaded. The index itself pushes nothing: it is the section's top, and
 * gets no back button (as before).
 */
const INDEX = 'linkrobins-wiki.index';
const INSIDE = ['linkrobins-wiki.show', 'linkrobins-wiki.edit', 'linkrobins-wiki.compose'];
export default function wikiBack() {
  extend(Page.prototype, 'oninit', function () {
    try {
      const route = this.attrs?.routeName;
      if (!INSIDE.includes(route)) return;
      const history = app.history;
      if (!history) return;
      const wiki = String(app.translator.trans('linkrobins-lr-home.forum.wiki_section'));
      if (history.getCurrent()?.name !== INDEX) history.push(INDEX, wiki, app.route(INDEX));
      history.push(route, document.title);
    } catch (e) {
      /* a back button is never worth a broken page */
    }
  });
}